const founderSec = document.querySelector('.founders-sec');

if (founderSec) {
  const foundersArr = document.querySelectorAll('.founders-sec__founder');

  if (foundersArr.length < 2) {
    console.warn('founders: need at least 2 elements');
  } else {
    const el1 = foundersArr[0];
    const el2 = foundersArr[1];

    const parent1 = el1.parentElement;
    const parent2 = el2.parentElement;

    const index1 = [...parent1.children].indexOf(el1);
    const index2 = [...parent2.children].indexOf(el2);

    const breakpoint = 768;

    const updateOrder = () => {
      const w = window.innerWidth;

      if (w > breakpoint) {
        if (parent1.children[index1] !== el1) {
          parent1.insertBefore(el1, parent1.children[index1] || null);
        }
        if (parent2.children[index2] !== el2) {
          parent2.insertBefore(el2, parent2.children[index2] || null);
        }
      } else {
        if (parent2.children[index2] !== el1) {
          parent2.insertBefore(el1, parent2.children[index2] || null);
        }
        if (parent1.children[index1] !== el2) {
          parent1.insertBefore(el2, parent1.children[index1] || null);
        }
      }
    };

    updateOrder();
    window.addEventListener('resize', updateOrder);
  }
}
